export enum SortProperty {
    Source,
    Supplier,
    Rating,
    Quantity,
    FirstPrice,
    Price,
    DeliveryDays,
    DeliveryDate
}
